import React from 'react';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Tag, X, Plus } from '@phosphor-icons/react';

export const CouponsSection = ({ coupons, updateCoupon, removeCoupon, addCoupon, currencySymbol }) => (
  <div className="space-y-3">
    {coupons.map((coupon, i) => (
      <div key={coupon._uid || `coupon-${i}`} className="p-3 bg-slate-50 rounded-lg border border-slate-200 space-y-2" data-testid={`coupon-row-${i}`}>
        <div className="flex items-center justify-between">
          <span className="text-xs font-semibold text-slate-600 flex items-center gap-1"><Tag size={14} /> Coupon {i + 1}</span>
          <button onClick={() => removeCoupon(i)} className="text-red-400 hover:text-red-600" data-testid={`remove-coupon-${i}`}><X size={14} /></button>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
          <div>
            <Label className="text-[11px] text-slate-500 mb-0.5 block">Code *</Label>
            <Input value={coupon.code} onChange={(e) => updateCoupon(i, 'code', e.target.value.toUpperCase())}
              placeholder="SAVE20" className="h-8 rounded text-xs uppercase" data-testid={`coupon-code-${i}`} />
          </div>
          <div>
            <Label className="text-[11px] text-slate-500 mb-0.5 block">Type</Label>
            <select value={coupon.discount_type} onChange={(e) => updateCoupon(i, 'discount_type', e.target.value)}
              className="w-full h-8 px-2 border border-slate-200 rounded text-xs bg-white" data-testid={`coupon-type-${i}`}>
              <option value="percentage">Percentage (%)</option>
              <option value="fixed">Fixed Amount</option>
            </select>
          </div>
          <div>
            <Label className="text-[11px] text-slate-500 mb-0.5 block">Value *</Label>
            <Input type="number" value={coupon.discount_value} onChange={(e) => updateCoupon(i, 'discount_value', e.target.value)}
              placeholder={coupon.discount_type === 'percentage' ? '20' : '100'} className="h-8 rounded text-xs" data-testid={`coupon-value-${i}`} />
          </div>
          <div>
            <Label className="text-[11px] text-slate-500 mb-0.5 block">Min Order ({currencySymbol})</Label>
            <Input type="number" value={coupon.min_order} onChange={(e) => updateCoupon(i, 'min_order', e.target.value)}
              placeholder="0" className="h-8 rounded text-xs" data-testid={`coupon-min-order-${i}`} />
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
          {coupon.discount_type === 'percentage' && (
            <div>
              <Label className="text-[11px] text-slate-500 mb-0.5 block">Max Discount ({currencySymbol})</Label>
              <Input type="number" value={coupon.max_discount} onChange={(e) => updateCoupon(i, 'max_discount', e.target.value)}
                placeholder="No limit" className="h-8 rounded text-xs" data-testid={`coupon-max-discount-${i}`} />
            </div>
          )}
          <div>
            <Label className="text-[11px] text-slate-500 mb-0.5 block">Valid From</Label>
            <Input type="date" value={coupon.valid_from} onChange={(e) => updateCoupon(i, 'valid_from', e.target.value)}
              className="h-8 rounded text-xs" data-testid={`coupon-valid-from-${i}`} />
          </div>
          <div>
            <Label className="text-[11px] text-slate-500 mb-0.5 block">Valid To</Label>
            <Input type="date" value={coupon.valid_to} onChange={(e) => updateCoupon(i, 'valid_to', e.target.value)}
              className="h-8 rounded text-xs" data-testid={`coupon-valid-to-${i}`} />
          </div>
        </div>
      </div>
    ))}
    <button onClick={addCoupon}
      className="flex items-center gap-1.5 text-xs text-emerald-600 hover:text-emerald-700 font-medium px-1"
      data-testid="add-coupon-btn">
      <Plus size={14} /> Add Coupon
    </button>
  </div>
);
